<app-main-banner></app-main-banner>

<section class="courses-categories-area bg-F7F9FB pt-100 pb-70">
  <div class="container">
    <div class="section-title">
      <span class="sub-title">Курсы</span>
      <h2>Просмотреть популярные категории</h2>
    </div>
    <app-courses-block></app-courses-block>
  </div>

  <div id="particles-js-circle-bubble-2"></div>
</section>

<app-features></app-features>

<section class="funfacts-style-two ptb-70">
  <div class="container">
    <app-funfacts></app-funfacts>
  </div>

  <div id="particles-js-circle-bubble"></div>
</section>

<section class="instructor-area pt-100 pb-70">
  <div class="container">
    <div class="section-title">
      <h2>Наши учителя</h2>
      <h6>Наши  опытные, квалифицированные, образованные педагоги</h6>
    </div>
    <app-instructors-style-two></app-instructors-style-two>
  </div>

  <div id="particles-js-circle-bubble-3"></div>
</section>
<app-exams-block></app-exams-block>
<section class="feedback-area ptb-100">
  <div class="container">
    <app-feedback-style-one></app-feedback-style-one>
  </div>
</section>
